<h2 mat-dialog-title class="dlg-title">
  Prescriptions
  @if (line) {<span class="dlg-sub">{{ name }}</span>}
</h2>
<mat-dialog-content class="dlg-body">
  @if (store.view && line) {
    @if (required) {
      <div class="banner">Le contrat de location nécessite une ordonnance ou une prescription. Sans prescription, il ne pourra pas être facturé à la sécurité sociale.</div>
    }
    @if (blocked) {
      <div class="blocked">{{ blocked }}</div>
    }

    @if (!blocked) {
      <section class="dlg-row">
        <div class="form-head">
          <span class="lbl">{{ formTitle }}</span>
          @if (replaceKey !== null) {<button type="button" class="link" (click)="newPrescription()">Saisir une nouvelle prescription à la place</button>}
        </div>
        <div class="rx-pick" role="group" aria-label="Matériels prescrits">
          <label class="hint rx-all" title="Cochez ce que l'ordonnance mentionne">
            @if (candidates.length > 1) {<input type="checkbox" [checked]="allOn" [indeterminate]="someOn" (change)="toggleAll($any($event.target))" aria-label="Tout cocher ou tout décocher" />}
            Matériels prescrits :
          </label>
          @for (c of candidates; track c.id) {
            <label class="rx-cand" [class.on]="c.checked">
              <input type="checkbox" [checked]="c.checked" (change)="toggleLine(c.id, $any($event.target).checked)" />
              <span class="nm">{{ c.name }}@if (c.memo) { · {{ c.memo }}}</span>
              <small>{{ c.covered }}</small>
            </label>
          }
        </div>
        <div class="fields rx-fields">
          <div class="field f-on" [class.target-ordo]="pickTarget === 'ordonnance'">
            <label for="rx-on">Date de l'ordonnance (obligatoire)</label>
            <div class="on-row">
              <input id="rx-on" type="text" [value]="prescribedValue" (focus)="setTarget('ordonnance')" (change)="typedPrescribedOn($event)" placeholder="JJ/MM/AAAA" autocomplete="off" />
              <button mat-icon-button type="button" class="mini" (click)="prescribedToStart()" [disabled]="!prescribedOn" matTooltip="Reprendre comme premier jour prescrit" aria-label="Reprendre la date de l'ordonnance comme premier jour prescrit"><mat-icon>arrow_forward</mat-icon></button>
            </div>
          </div>
          <div class="field f-day" [class.target-start]="pickTarget === 'start'">
            <label for="rx-start">Premier jour prescrit</label>
            <input id="rx-start" type="text" [value]="startValue" (focus)="setTarget('start')" (change)="typedStart($event)" placeholder="JJ/MM/AAAA" autocomplete="off" />
          </div>
          <div class="field f-end" [class.target-start]="endMode === 'end' && pickTarget === 'start' && !!start">
            <div class="seg mini" role="group" aria-label="Fin de la prescription">
              <button type="button" [attr.aria-pressed]="endMode === 'end'" (click)="setEndMode('end')">Dernier jour</button>
              <button type="button" [attr.aria-pressed]="endMode === 'duration'" (click)="setEndMode('duration')">Durée</button>
            </div>
            @if (endMode === 'end') {
              <input id="rx-last" type="text" [value]="endValue" (focus)="setTarget('start')" (change)="typedEnd($event)" placeholder="JJ/MM/AAAA" autocomplete="off" aria-label="Dernier jour couvert (inclus)" matTooltip="Dernier jour couvert (inclus)" />
            } @else {
              <div class="dur">
                <input id="rx-duration" type="number" min="1" step="1" [value]="durationText" (input)="setDuration($any($event.target).value)" placeholder="Nombre" aria-label="Durée prescrite" matTooltip="Le dernier jour est calculé par le serveur." />
                <mat-select class="unit" [value]="unit" (selectionChange)="setUnit($event.value)" aria-label="Unité de la durée">
                  @for (u of units; track u.value) {
                    <mat-option [value]="u.value">{{ u.label }}</mat-option>
                  }
                </mat-select>
              </div>
            }
          </div>
          <div class="field f-ref">
            <label for="rx-ref">N° du prescripteur (obligatoire)</label>
            <input id="rx-ref" type="text" [value]="reference" (input)="setReference($any($event.target).value)" placeholder="RPPS ou n° Assurance Maladie" autocomplete="off" />
          </div>
          <div class="field rx-file">
            <label for="rx-file">Ordonnance (fichier, obligatoire)</label>
            <div class="file-row">
              <input #newFile id="rx-file" type="file" hidden multiple accept="application/pdf,image/*" (change)="pickPending($event)" />
              <button mat-stroked-button type="button" class="mini" (click)="newFile.click()" matTooltip="Joindre le fichier de l'ordonnance (PDF ou image)"><mat-icon>attach_file</mat-icon>Importer</button>
              @for (p of pending; track $index) {<span class="pending"><button type="button" class="link" (click)="previewPending($index)" matTooltip="Voir le fichier avant d'enregistrer">{{ p.name }}</button> <small class="as">→ {{ pendingName($index) }}</small> <button mat-icon-button type="button" class="mini" (click)="removePending($index)" [attr.aria-label]="'Retirer ' + p.name" matTooltip="Retirer"><mat-icon>close</mat-icon></button></span>}
              @if (!pending.length) {<span class="help">{{ fileHelp }}</span>}
            </div>
          </div>
        </div>
        @if (replaceKey !== null) {
          <input class="comment" type="text" [value]="replaceReason" (input)="setReplaceReason($any($event.target).value)"
            placeholder="Motif du remplacement (obligatoire)" aria-label="Motif du remplacement" />
        }
        @if (leftMonth; as lm) {
          <app-rental-day-picker [mode]="endMode === 'end' ? 'range' : 'single'" [start]="start" [end]="endMode === 'end' ? end : null"
            [leftMonth]="lm" [monthCount]="months" [sixWeeks]="true" [dense]="true" [today]="store.view.as_of" [marks]="marks" tone="orange" [phase]="pickPhase" (phaseChange)="onPickPhase($event)"
            [captureDay]="pickTarget === 'ordonnance'" [ringDay]="prescribedOn" (dayPick)="pickPrescribedOn($event)"
            (startChange)="setStart($event)" (endChange)="setEnd($event)" (leftMonthChange)="setLeftMonth($event)" (escape)="close()"></app-rental-day-picker>
        }
      </section>
    }

    <section class="dlg-row">
      <div class="lbl">Prescriptions du dossier</div>
      @if (filesError) {
        <div class="blocked files-error">{{ filesError }} <button mat-stroked-button type="button" class="retry-files" (click)="loadFiles()">Réessayer</button></div>
      }
      @if (rows.length) {
        <ul class="hist">
          @for (r of rows; track r.key) {
            <li [class.cancelled]="!r.live" [class.current]="r.key === replaceKey">
              <div class="main">
                <span class="what">{{ r.what }}@if (r.extra) { · {{ r.extra }}}</span>
                <span class="rx-lines">{{ r.lines }}</span>
                <small>{{ r.stamp }}@if (r.replaces) { · remplace n° {{ r.replaces }}}</small>
                @if (r.cancelled) {<small>{{ r.cancelled }}</small>}
                @if (r.files.length) {
                  <div class="files">
                    @for (f of r.files; track f.id) {<button type="button" class="link" (click)="openFile(f)" title="Ouvrir">{{ f.name }}</button>}
                  </div>
                }
              </div>
              @if (r.live && !blocked) {
                <div class="acts">
                  <input #rowFile type="file" hidden multiple accept="application/pdf,image/*" (change)="attachTo(r.key, $event)" />
                  <button mat-stroked-button type="button" (click)="rowFile.click()" [disabled]="attaching !== null" matTooltip="Joindre le fichier de cette ordonnance"><mat-icon>attach_file</mat-icon>{{ attaching === r.key ? 'Dépôt…' : 'Importer' }}</button>
                  <button mat-stroked-button type="button" (click)="replace(r.key)" [disabled]="r.key === replaceKey">Remplacer</button>
                  <button mat-stroked-button color="warn" type="button" (click)="cancel(r.key)">Annuler</button>
                </div>
              }
            </li>
          }
        </ul>
      } @else {
        <div class="hint">Aucune prescription saisie sur ce dossier.</div>
      }
    </section>
  } @else if (store.error) {
    <div class="blocked">{{ store.error }}</div>
  } @else if (store.view) {
    <div class="blocked">Ligne {{ data.lineId }} absente du dossier.</div>
  } @else {
    <div class="loading"><mat-spinner diameter="24"></mat-spinner>Chargement du dossier</div>
  }
</mat-dialog-content>
<div class="dlg-effect">
  <app-rental-effect [state]="sim" [rangeText]="rangeText" [warnings]="[]" [errors]="errors" [scope]="scope" [focusLineIds]="focusIds" [store]="store"></app-rental-effect>
</div>
<mat-dialog-actions class="dlg-actions">
  <span class="spacer"></span>
  <button mat-stroked-button type="button" (click)="close()" [disabled]="saving">Fermer</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!canSave" (click)="save()">{{ replaceKey !== null ? 'Remplacer' : 'Enregistrer' }}</button>
</mat-dialog-actions>
